import { DEFAULT_PLACEMENT_DESKTOP, DEFAULT_PLACEMENT_MOBILE } from '../../../internal/constants/toast';
/**
 * Функция, возвращающая результирующее положение тостов на экране.
 * @param placement - входящее значение положения тостов на экране, может быть undefined
 * @param isMobileDevice - работает ли тост в контексте мобильного устройства
 * @returns TToastContainerPlacement - финальное значение положения тостов на экране.
 */
export function getToastPlacement(placement, isMobileDevice) {
  if (isMobileDevice) {
    return DEFAULT_PLACEMENT_MOBILE;
  }
  return placement || DEFAULT_PLACEMENT_DESKTOP;
}